/** Tipos de carrocería (coinciden con VehicleType de la API). */
export type BodyType = 'SEDAN' | 'SUV' | 'HATCHBACK' | 'MINIVAN' | 'VAN' | 'PICKUP' | 'LUXURY' | 'OTHER';

export interface CatalogModel {
  name: string;
  type: BodyType;
  /** Pasajeros sin contar al conductor. */
  seats: number;
}

const m = (name: string, type: BodyType, seats = 4): CatalogModel => ({ name, type, seats });

/**
 * Marcas y modelos más comunes en República Dominicana. Si el del conductor no está,
 * puede escribirlo a mano ("Otra marca" / "Otro modelo").
 */
export const VEHICLE_CATALOG: Record<string, CatalogModel[]> = {
  Toyota: [m('Corolla', 'SEDAN'), m('Camry', 'SEDAN'), m('Yaris', 'HATCHBACK'), m('RAV4', 'SUV'), m('Highlander', 'SUV', 6), m('4Runner', 'SUV'), m('Land Cruiser Prado', 'SUV', 6), m('Land Cruiser', 'SUV', 6), m('Fortuner', 'SUV', 6), m('Hilux', 'PICKUP'), m('Tacoma', 'PICKUP'), m('Sienna', 'MINIVAN', 7), m('Hiace', 'VAN', 12), m('C-HR', 'SUV'), m('Rush', 'SUV', 6)],
  Hyundai: [m('Sonata', 'SEDAN'), m('Elantra', 'SEDAN'), m('Accent', 'SEDAN'), m('Avante', 'SEDAN'), m('i10', 'HATCHBACK'), m('Grand i10', 'HATCHBACK'), m('Tucson', 'SUV'), m('Santa Fe', 'SUV', 6), m('Creta', 'SUV'), m('Kona', 'SUV'), m('Palisade', 'SUV', 7), m('Venue', 'SUV'), m('H-1', 'VAN', 11), m('Staria', 'VAN', 10)],
  Kia: [m('K5', 'SEDAN'), m('Optima', 'SEDAN'), m('Rio', 'SEDAN'), m('Forte', 'SEDAN'), m('Picanto', 'HATCHBACK'), m('Morning', 'HATCHBACK'), m('Soul', 'HATCHBACK'), m('Sportage', 'SUV'), m('Sorento', 'SUV', 6), m('Seltos', 'SUV'), m('Sonet', 'SUV'), m('Telluride', 'SUV', 7), m('Carnival', 'MINIVAN', 7)],
  Honda: [m('Civic', 'SEDAN'), m('Accord', 'SEDAN'), m('City', 'SEDAN'), m('Fit', 'HATCHBACK'), m('CR-V', 'SUV'), m('HR-V', 'SUV'), m('Pilot', 'SUV', 7), m('Odyssey', 'MINIVAN', 7)],
  Nissan: [m('Sentra', 'SEDAN'), m('Versa', 'SEDAN'), m('Altima', 'SEDAN'), m('March', 'HATCHBACK'), m('Kicks', 'SUV'), m('X-Trail', 'SUV'), m('Rogue', 'SUV'), m('Pathfinder', 'SUV', 6), m('Patrol', 'SUV', 7), m('Frontier', 'PICKUP'), m('Navara', 'PICKUP'), m('Urvan', 'VAN', 14)],
  Mitsubishi: [m('Lancer', 'SEDAN'), m('Mirage', 'HATCHBACK'), m('ASX', 'SUV'), m('Outlander', 'SUV', 6), m('Montero Sport', 'SUV', 6), m('Montero', 'SUV', 6), m('Xpander', 'MINIVAN', 6), m('L200', 'PICKUP')],
  Suzuki: [m('Swift', 'HATCHBACK'), m('Alto', 'HATCHBACK'), m('Celerio', 'HATCHBACK'), m('Dzire', 'SEDAN'), m('Ciaz', 'SEDAN'), m('Vitara', 'SUV'), m('Grand Vitara', 'SUV'), m('Jimny', 'SUV', 3), m('Ertiga', 'MINIVAN', 6)],
  Chevrolet: [m('Spark', 'HATCHBACK'), m('Aveo', 'SEDAN'), m('Onix', 'SEDAN'), m('Cruze', 'SEDAN'), m('Malibu', 'SEDAN'), m('Tracker', 'SUV'), m('Equinox', 'SUV'), m('Captiva', 'SUV', 6), m('Traverse', 'SUV', 7), m('Tahoe', 'SUV', 7), m('Suburban', 'SUV', 8), m('Colorado', 'PICKUP'), m('Silverado', 'PICKUP')],
  Ford: [m('Fiesta', 'HATCHBACK'), m('Focus', 'SEDAN'), m('Fusion', 'SEDAN'), m('EcoSport', 'SUV'), m('Escape', 'SUV'), m('Edge', 'SUV'), m('Explorer', 'SUV', 6), m('Expedition', 'SUV', 7), m('Everest', 'SUV', 6), m('Ranger', 'PICKUP'), m('F-150', 'PICKUP'), m('Transit', 'VAN', 12)],
  Mazda: [m('Mazda 2', 'HATCHBACK'), m('Mazda 3', 'SEDAN'), m('Mazda 6', 'SEDAN'), m('CX-3', 'SUV'), m('CX-30', 'SUV'), m('CX-5', 'SUV'), m('CX-9', 'SUV', 6), m('BT-50', 'PICKUP')],
  Jeep: [m('Wrangler', 'SUV'), m('Cherokee', 'SUV'), m('Grand Cherokee', 'SUV'), m('Compass', 'SUV'), m('Renegade', 'SUV'), m('Gladiator', 'PICKUP')],
  Volkswagen: [m('Jetta', 'SEDAN'), m('Polo', 'HATCHBACK'), m('Golf', 'HATCHBACK'), m('Virtus', 'SEDAN'), m('T-Cross', 'SUV'), m('Tiguan', 'SUV'), m('Amarok', 'PICKUP')],
  Isuzu: [m('D-Max', 'PICKUP'), m('MU-X', 'SUV', 6)],
  Daihatsu: [m('Terios', 'SUV'), m('Sirion', 'HATCHBACK')],
  Chery: [m('Tiggo 2', 'SUV'), m('Tiggo 4', 'SUV'), m('Tiggo 7', 'SUV'), m('Tiggo 8', 'SUV', 6), m('Arrizo 5', 'SEDAN')],
  Geely: [m('Coolray', 'SUV'), m('Emgrand', 'SEDAN'), m('Azkarra', 'SUV'), m('Okavango', 'SUV', 6)],
  JAC: [m('JS2', 'SUV'), m('JS4', 'SUV'), m('T8', 'PICKUP')],
  Changan: [m('CS35', 'SUV'), m('CS55', 'SUV'), m('Alsvin', 'SEDAN')],
  'Mercedes-Benz': [m('Clase C', 'LUXURY'), m('Clase E', 'LUXURY'), m('Clase S', 'LUXURY'), m('GLA', 'SUV'), m('GLC', 'SUV'), m('GLE', 'SUV'), m('Sprinter', 'VAN', 14)],
  BMW: [m('Serie 3', 'LUXURY'), m('Serie 5', 'LUXURY'), m('X1', 'SUV'), m('X3', 'SUV'), m('X5', 'SUV')],
  Audi: [m('A3', 'LUXURY'), m('A4', 'LUXURY'), m('A6', 'LUXURY'), m('Q3', 'SUV'), m('Q5', 'SUV'), m('Q7', 'SUV', 6)],
  Lexus: [m('ES', 'LUXURY'), m('IS', 'LUXURY'), m('NX', 'SUV'), m('RX', 'SUV'), m('GX', 'SUV', 6), m('LX', 'SUV', 7)],
  Subaru: [m('Impreza', 'SEDAN'), m('Forester', 'SUV'), m('Outback', 'SUV'), m('XV', 'SUV')],
  Peugeot: [m('208', 'HATCHBACK'), m('301', 'SEDAN'), m('2008', 'SUV'), m('3008', 'SUV'), m('5008', 'SUV', 6)],
  Renault: [m('Logan', 'SEDAN'), m('Sandero', 'HATCHBACK'), m('Duster', 'SUV'), m('Koleos', 'SUV')],
};

export const MAKES = Object.keys(VEHICLE_CATALOG).sort((a, b) => a.localeCompare(b, 'es'));

export const findModel = (make: string, model: string) => VEHICLE_CATALOG[make]?.find((x) => x.name.toLowerCase() === model.trim().toLowerCase()) ?? null;

export interface CatalogColor {
  name: string;
  hex: string;
}

export const VEHICLE_COLORS: CatalogColor[] = [
  { name: 'Negro', hex: '#16171a' },
  { name: 'Blanco', hex: '#f4f5f6' },
  { name: 'Gris', hex: '#7b8088' },
  { name: 'Plateado', hex: '#c3c7cc' },
  { name: 'Gris oscuro', hex: '#45484e' },
  { name: 'Azul', hex: '#1f4fa3' },
  { name: 'Azul oscuro', hex: '#1b2a4a' },
  { name: 'Rojo', hex: '#c0202a' },
  { name: 'Vino', hex: '#6b1824' },
  { name: 'Beige', hex: '#d8c7a5' },
  { name: 'Marrón', hex: '#5a3f2b' },
  { name: 'Verde', hex: '#2f5d3a' },
  { name: 'Dorado', hex: '#b8975a' },
  { name: 'Amarillo', hex: '#e8c22a' },
  { name: 'Naranja', hex: '#d9661f' },
];

/** Color para la ilustración a partir del nombre escrito ("negro", "Gris plata"…). */
export function colorHex(name: string | null | undefined): string {
  const n = (name ?? '').trim().toLowerCase();
  if (!n) return '#9aa0a6';
  const exact = VEHICLE_COLORS.find((c) => c.name.toLowerCase() === n);
  if (exact) return exact.hex;
  const word = VEHICLE_COLORS.find((c) => n.includes(c.name.toLowerCase().split(' ')[0]!));
  if (word) return word.hex;
  if (/plat|silver/.test(n)) return '#c3c7cc';
  if (/blanc|white|perla/.test(n)) return '#f4f5f6';
  if (/negr|black/.test(n)) return '#16171a';
  if (/azul|blue/.test(n)) return '#1f4fa3';
  if (/roj|red/.test(n)) return '#c0202a';
  return '#9aa0a6';
}
